/*
 * -----------------------------------------------------------------------
 *  <copyright file="add-rules/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { useQuery } from '@apollo/client/react';
import cn from 'clsx';
import React, { useEffect, useState } from 'react';
import { ADD_RULES_FIELD_DATA } from '@components/admin/add-rules/add-rules.data';
import { AddRulesProps, StudyRulesField } from '@components/admin/add-rules/add-rules.interface';
import RulesRow from '@components/admin/add-rules/rules-row';
import { SelectWithSearchDataArrayInterface } from '@components/core/select-with-categories/select-with-categories.interface';
import { GET_SUBJECT_VISIT_TEMPLATE_RULES_FIELDS } from '@queries/study-visit-schedules';

const AddRules = ({ formState, setFormState, studyId, hidden, showValidation }: AddRulesProps) => {
    const [rulesFields, setRulesFields] = useState(ADD_RULES_FIELD_DATA);

    const { data } = useQuery(GET_SUBJECT_VISIT_TEMPLATE_RULES_FIELDS, {
        variables: { studyId },
    });

    useEffect(() => {
        const studyRulesFields: StudyRulesField[] = data?.studyRulesFields;

        if (studyRulesFields) {
            const fields: SelectWithSearchDataArrayInterface[] = studyRulesFields.map((field) => ({
                id: field.fieldName,
                text: field.friendlyName,
                type: field.fieldType,
            }));
            fields.unshift(ADD_RULES_FIELD_DATA[0]);
            setRulesFields(fields);
        }
    }, [data]);

    return (
        <div className={cn('add-rules', { hidden })}>
            {formState.map((rule, index) => (
                <RulesRow
                    key={rule.key}
                    rulesFields={rulesFields}
                    formState={formState}
                    setFormState={setFormState}
                    ruleIndex={index}
                    isLast={formState.length === index + 1}
                    showValidation={showValidation}
                />
            ))}
        </div>
    );
};

export default AddRules;
